import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('core');

export class Cities extends Api {
  constructor(http, config = {}) {
    super(http, url, 'cities', config);
  }
}
